"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconImproveEfficiency = function SvgIconImproveEfficiency(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "improve efficiency icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Improve Efficiency Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.104 12.31l.46.69c.21.312.56.5.937.5h.037c.39-.014.745-.228.94-.566l3-5.25A1.126 1.126 0 0037.36 6.01l-6 .75a1.124 1.124 0 00-.796 1.74l.46.69a.376.376 0 01-.105.52L9.668 23.878a1.5 1.5 0 001.665 2.496l21.252-14.168a.374.374 0 01.52.104zm7.022 24.612h-5.25a.373.373 0 01-.375-.375v-18a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5v18a.374.374 0 01-.375.375zM27 23.047a1.5 1.5 0 00-1.5 1.5v12a.374.374 0 00.374.375h5.25a.373.373 0 00.376-.375v-12a1.5 1.5 0 00-1.5-1.5h-3zm-10.5 6.75a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5v6.75a.374.374 0 01-.376.375h-5.25a.373.373 0 01-.375-.375v-6.75zm-9.001 4.5a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5v2.25a.374.374 0 01-.375.375h-5.25a.374.374 0 01-.375-.375v-2.25zM40.5 42h-33a1.5 1.5 0 110-3h33a1.5 1.5 0 010 3z"
  }));
};

var _default = SvgIconImproveEfficiency;
exports.default = _default;